/**
 * This interceptor replaces entity refs in VPC if a product in the VPC has ha "replacedBy" meta data property
 * and the current market doesn't sell the specific product in the VPC but sells it's replacement product.
 */
export default class ReplaceProductInterceptor {
    constructor(validProducts, invalidProducts) {
        this.validProducts = validProducts;
        this.invalidProducts = invalidProducts;
    }
    beforeDeserialize(json) {
        const data = JSON.parse(json);
        const entities = data.entities;
        const replacedEntities = entities?.map((entity) => {
            const invalidProduct = this.invalidProducts.find(product => product.coreProductId === entity.ref);
            if (invalidProduct) {
                const replacementProduct = invalidProduct.meta?.replacedBy;
                if (this.validProducts.find(product => product.coreProductId === replacementProduct)) {
                    return { ...entity, ref: replacementProduct };
                }
            }
            return entity;
        });
        return JSON.stringify({ ...data, entities: replacedEntities });
    }
    beforeParsingComponents() { }
    beforeBuildingEntities() { }
    afterDeserializeComplete() { }
}
//# sourceMappingURL=ReplaceProductInterceptor.js.map